import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { Redirect, Route } from 'react-router-dom';
import {
  IonGrid,
  IonRow,
  IonCol,
  IonContent,
  IonHeader, IonPage, IonTitle, IonToolbar,
  IonBackButton,
  IonButtons,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact,
  IonButton,
  IonRouterContext,
  IonRouteProps,
  IonLoading,
  IonToast,
  IonFab,
  IonFabButton,
  IonPopover,
  IonList,
  IonSegment,
  IonSegmentButton
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import { ticketOutline, ellipsisVerticalOutline, cubeOutline, albumsOutline } from 'ionicons/icons';
import './Backup.css';
import { getLoginApp, getchek } from '../../utils/functions';
import { API } from '../../constants/system';
import { baseurl } from '../../constants/constants';
import BackupActions from '../../actions/BackupActions';

import {
  queryAllLocations,
  createLocationTest,
  queryAllPermisions,
  queryAllConfiguration,
  queryAllActivities,
} from "../../data_base_local/dataservice";

interface IProps {
  setData: any;
  get_: any;
}

interface IState {
  loading: any;
  segmentActive: any;
  dataLocations: any;
  dataConfigurations: any;
  dataPermissions: any;
  dataActivities: any;
}

class Backup extends React.Component<IProps, IState> {
  contentRef: React.RefObject<HTMLIonContentElement>;
  popover: React.RefObject<HTMLIonPopoverElement>;

  constructor(props: any) {
    super(props)

    this.popover = React.createRef<HTMLIonPopoverElement>();
    this.contentRef = React.createRef<HTMLIonContentElement>();

    this.state = {
      loading: props.loading,
      segmentActive: props.segmentActive,
      dataLocations: props.dataLocations,
      dataConfigurations: props.dataConfigurations,
      dataPermissions: props.dataPermissions,
      dataActivities: props.dataActivities
    }

  }

  async GetAllLocations() {
    let data = await queryAllLocations().then();
    return data.values;
  };

  async SetLocation() {
    await createLocationTest().then();
  };

  async GetAllPermisions() {
    let data = await queryAllPermisions().then();
    return data.values;
  };

  async GetAllConfiguration() {
    let data = await queryAllConfiguration().then();
    return data.values;
  };

  async GetAllActivities() {
    let data = await queryAllActivities().then();
    return data.values;
  };
  UNSAFE_componentWillReceiveProps(nextProps: any) {

  }

  async componentDidMount() {
    this.setState({
      loading: false,
      segmentActive: "locations",
      dataLocations: [],
      dataConfigurations: [],
      dataPermissions: [],
      dataActivities: []
    });
  }

  async btnGetPositions() {
    let dataLocations = await this.GetAllLocations();
    this.setState({ dataLocations });
  }

  async btnGetActivities() {
    let dataActivities = await this.GetAllActivities();
    this.setState({ dataActivities });
  }

  async btnSetPositionTest() {
    this.SetLocation();
    this.btnGetPositions();
  }

  async btnGetPermisions() {
    let dataPermissions = await this.GetAllPermisions();
    this.setState({ dataPermissions });
  }

  async btnGetConfiguration() {
    let dataConfigurations = await this.GetAllConfiguration();
    this.setState({ dataConfigurations });
  }

  render() {
    const { segmentActive, dataLocations, dataPermissions, dataConfigurations, dataActivities } = this.state;
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonBackButton defaultHref="/home" text={""} />
            </IonButtons>
            <IonTitle style={{ fontSize: "15px" }}>LOCAL DATABASE</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen ref={this.contentRef} scrollEvents={true}>
          {
            <IonToolbar color="primary">
              <IonSegment value={segmentActive} scrollable>
                <IonSegmentButton
                  value="1"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'locations'
                    });
                  }}
                >
                  <IonLabel>Locaciones</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="2"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'permisions'
                    });
                  }}
                >
                  <IonLabel>Permisos</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="2"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'configuration'
                    });
                  }}
                >
                  <IonLabel>Configuración</IonLabel>
                </IonSegmentButton>

                <IonSegmentButton
                  value="2"
                  onClick={() => {
                    this.setState({
                      segmentActive: 'activities'
                    });
                  }}
                >
                  <IonLabel>Actividades</IonLabel>
                </IonSegmentButton>
              </IonSegment>
            </IonToolbar>
          }
          {
            segmentActive == "locations" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetPositions()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>{/*
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnSetPositionTest()}>
                      <strong>Locación Tst</strong>
                    </IonButton>
                  </IonCol>*/}
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Lat</th>
                            <th>Lng</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataLocations.length > 0 && dataLocations.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.lat}</td>
                                <td>{val.lng}</td>
                                <td>{val.datetime}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "permisions" ?
              <>
                <IonRow>
                  <IonCol col-12 size='12' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetPermisions()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>name</th>
                            <th>status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataPermissions && dataPermissions.length > 0 && dataPermissions.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.name}</td>
                                <td>{val.status}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "configuration" ?
              <>
                <IonRow>
                  <IonCol col-12 size='12' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetConfiguration()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>token</th>
                            <th>data_login</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataConfigurations && dataConfigurations.length > 0 && dataConfigurations.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.token}</td>
                                <td>{val.data_login}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
          {
            segmentActive == "activities" ?
              <>
                <IonRow>
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnGetActivities()}>
                      <strong>Todas</strong>
                    </IonButton>
                  </IonCol>{/*
                  <IonCol col-6 size='6' >
                    <IonButton size="default" color="tertiary" onClick={() => this.btnSetPositionTest()}>
                      <strong>Locación Tst</strong>
                    </IonButton>
                  </IonCol>*/}
                  <IonCol col-12 size='12' >

                    <div className="data-table-container">
                      <table className="data-table">
                        <thead>
                          <tr>
                            <th>id</th>
                            <th>Log</th>
                            <th>Descripción</th>
                            <th>Usuario</th>
                            <th>Fecha</th>
                          </tr>
                        </thead>
                        <tbody>
                          {dataActivities.length > 0 && dataActivities.map((val: any, key: any) => {
                            return (
                              <tr key={key}>
                                <td>{val.id}</td>
                                <td>{val.log_name}</td>
                                <td>{val.description}</td>
                                <td>{val.user_id}</td>
                                <td>{val.date}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  </IonCol>
                </IonRow>
              </>
              :
              null
          }
        </IonContent>
      </IonPage>
    );
  };
}

const mapStateToProps = (state: any) => {
  return {
    setData: PropTypes.func.isRequired,
    data: state.data,
    _get: PropTypes.func.isRequired,
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    setData: (item: string) => dispatch(BackupActions.setData(item)),
    get_: (fields: any, controller: string) => dispatch(BackupActions.get_(fields, controller)),

  }
};

export default connect(mapStateToProps, mapDispatchToProps)(Backup);
